import ApiService from '../../../../service/ApiService';
import { AOI_ENDPOINTS } from './endpoints';

export const createGeoFeature = (missionId: string, scenarioId: string, body: object) =>
  ApiService.post(AOI_ENDPOINTS.create(missionId, scenarioId), body);

export const getAllGeoFeatures = (missionId: string, scenarioId: string) =>
  ApiService.get(AOI_ENDPOINTS.getAll(missionId, scenarioId));

export const getGeoFeatureById = (missionId: string, scenarioId: string, aoiId: string) =>
  ApiService.get(AOI_ENDPOINTS.getById(missionId, scenarioId, aoiId));

export const updateGeoFeatureApi = (missionId: string, scenarioId: string, aoiId: string, body: object) =>
  ApiService.patch(AOI_ENDPOINTS.update(missionId, scenarioId, aoiId), body);

export const deleteGeoFeature = (missionId: string, scenarioId: string, aoiId: string) =>
  ApiService.delete(AOI_ENDPOINTS.delete(missionId, scenarioId, aoiId));

export const deleteGeoFeatures = (missionId: string, scenarioId: string, areaOfInterestIds: string[]) =>
  ApiService.post(AOI_ENDPOINTS.deleteMany(missionId, scenarioId), { areaOfInterestIds });

export const renameGeoFeature = async (missionId: string, scenarioId: string, aoiId: string, name: string) => {
  const res = await getGeoFeatureById(missionId, scenarioId, aoiId);
  const current = res?.data?.data ?? res?.data ?? {};
  return updateGeoFeatureApi(missionId, scenarioId, aoiId, {
    ...current,
    name,
  });
};
